import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Grid from "@mui/material/Grid2";
import moment from "moment";
import { tableStyles } from 'src/shared/util/tableStyles';
import { Box } from '@mui/material';

export interface ITableProps {
    filteredData: any[],
    filters: any[]
}


const WaterTest = ({filteredData, filters }: ITableProps) => {

    const { waterTests } = useSelector((state) => state.location);

    const [waterDataTable, setWaterDataTable] = useState<any[]>([])

    const [dataColumns, setDataColumns] = useState<GridColDef[]>([
        {
            field: "samplingDate",
            headerName: "Fecha de Muestra",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "receptionDate",
            headerName: "Fecha de Recepción",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "freeWaterPercentage",
            headerName: "% Agua Libre",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "emulsionPercentage",
            headerName: "% Emulsión",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "emulsifiedWaterPercentage",
            headerName: "% Agua Emulsionada",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "totalWaterPercentage",
            headerName: "% Agua Total ",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "sedimentPercentage",
            headerName: "% Sedimentos",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "observations",
            headerName: "Observaciones",
            width: 80,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
    ]);

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {
        const datToTable: any[] = []

        let sortActivities: any[] = [...waterTests].sort((a: any, b: any) => new Date(b.samplingDate).getTime() - new Date(a.samplingDate).getTime());

        for (const filter of filters) {
            const filterData = filteredData.find(f => f.name === filter.name);
            if (filterData) {
                if (filterData.action === 'greater') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                } else if (filterData.action === 'less') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                } else if (filterData.action === 'equal') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                } else if (filterData.action === 'different') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                } else if (filterData.action === 'dissable') {
                    sortActivities = sortActivities || [];
                } else if (filterData.action === 'include' && filterData.value.length > 0) {
                    sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                } else if (filterData.action === 'equalAfter') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.samplingDate);
                        return locationDate.isSameOrAfter(filterData.value, 'day')
                    });
                } else if (filterData.action === 'equalBefore') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.samplingDate)
                        return locationDate.isSameOrBefore(filterData.value, 'day')
                    });
                }
            }
        }

        for (const act of sortActivities) {
            const data:any = {
                id: act.id,
                samplingDate: act.samplingDate,
                receptionDate: act.receptionDate,
                freeWaterPercentage: act.freeWaterPercentage,
            }


            const dateField= ['samplingDate','receptionDate']

            for (const field of dateField) {
                if (act[field]) {
                    try {
                        data[field] = moment(act[field]).format('DD-MM-YYYY')
                    } catch (error) {
                        
                    }
                }
            }

            const doubleField = ['freeWaterPercentage','emulsionPercentage','emulsifiedWaterPercentage','totalWaterPercentage','sedimentPercentage']

            for (const field of doubleField) {
                if (act[field]) {
                    try {
                        data[field] = parseFloat(act[field])
                    } catch (error) {
                        
                    }
                }
            }

            const stringField = ['observations']
            for (const field of stringField) {
                if (act[field]) {
                    try {
                        data[field] = act[field]
                    } catch (error) {
                    }
                }
            }

            datToTable.push(data)
        }

        setWaterDataTable(datToTable)

    }, [waterTests,filters])


    return (
        <Box className="table-container">
            <DataGrid
                rows={waterDataTable}
                columns={dataColumns}
                initialState={{
                    pagination: { paginationModel }
                }}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                   ...tableStyles
                }}
                getRowId={(row) => row.id}
            />
        </Box>
    )
}

export default WaterTest